import createShapeFromProperties from '../../../properties/createShapeFromProperties';
import definition from './definition';
import getAngusLogin from './getAngusLogin';

export { getAngusLogin, definition };

export const validationShape = createShapeFromProperties(
  definition.interactionData
);
